/**
 * AES-256-CBC encryption matching Unity's Encryptor.cs
 * Key: "9b9b9b9b9b9b9b9b9b9b9b9b9b9b9b96" (32 ASCII bytes)
 * IV: "9b9b9b9b9b9b9b9b" (16 ASCII bytes)
 * Padding: PKCS7 (Web Crypto default for AES-CBC)
 */

const ENCRYPTION_KEY_RAW = new TextEncoder().encode("9b9b9b9b9b9b9b9b9b9b9b9b9b9b9b96");
const ENCRYPTION_IV = new TextEncoder().encode("9b9b9b9b9b9b9b9b");

let cachedKey: CryptoKey | null = null;

async function getKey(): Promise<CryptoKey> {
  if (cachedKey) return cachedKey;
  cachedKey = await crypto.subtle.importKey("raw", ENCRYPTION_KEY_RAW, { name: "AES-CBC" }, false, [
    "encrypt",
  ]);
  return cachedKey;
}

/** Returns true if this media type should be encrypted (matches Unity: everything except video, audio, gif, avatar) */
export function shouldEncrypt(mediaType: string): boolean {
  const noEncryptTypes = ["video", "audio", "gif", "avatar"];
  return !noEncryptTypes.includes(mediaType);
}

/** Encrypt data using AES-256-CBC, matching Unity's Encryptor.EncryptBytes() */
export async function encryptMedia(data: Uint8Array): Promise<Uint8Array> {
  const key = await getKey();
  const encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv: ENCRYPTION_IV }, key, data);
  return new Uint8Array(encrypted);
}
